import { render } from "./CompletedTrainingIcon.vue?vue&type=template&id=e3d7e6ba"
const script = {}

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__